export default __webpack_public_path__ + "static/media/logo.d85c2567.png";